import * as React from 'react';

import { localization } from 'src/App/shared/localization/localization';
import { EditorErrorDialog } from './editor-error.dialog';

export interface ISaveMotiveErrorDialogProps {
    errorMessage: string;
    onClose(): void;
}

export const SaveMotiveErrorDialog = (props: ISaveMotiveErrorDialogProps) => {
    return (
        <EditorErrorDialog
            title={localization.editorLoc.logoEditorContent.savingMotiveDialogTitle}
            msgContent={localization.editorLoc.logoEditorContent.savingMotiveErrorDialogMsg}
            errorMessage={props.errorMessage}
            onClose={props.onClose}
        /> 
    );
};



// WEBPACK FOOTER //
// ./src/App/logo-app/logo-editor/logo-editor-dialogs/save-motive-error.dialog.tsx